<template>
  <div class="form-group no-gutters row">
    <div class="col-sm-3">
      <select class="form-control" v-model="value.countryISO" :required="required">
        <option value="GB">UK (+44)</option>
        <optgroup label="other countries">
          <option :value="country.iso" v-for="country in countries" :key="country.iso">{{country.name}} ({{country.phone}})</option>
        </optgroup>
      </select>
    </div>
    <div class="col-sm-9">
      <input type="tel" class="form-control" v-model="value.phoneNumber" :required="required">
      <div class="invalid-feedback">Phone number is required.</div>
    </div>
  </div>
</template>

<script>
  import countries from '@/utils/countries'

  export default {
    data () {
      return {
        countries: countries.filter(country => country.iso !== 'GB')
      }
    },
    props: {
      required: Boolean,
      value: {
        countryISO: String,
        phoneNumber: String
      }
    }
  }
</script>

<style scoped>
</style>
